import { render, staticRenderFns } from "./keluargaKatolik.vue?vue&type=template&id=55b14eed&scoped=true&"
import script from "./keluargaKatolik.vue?vue&type=script&lang=js&"
export * from "./keluargaKatolik.vue?vue&type=script&lang=js&"
import style0 from "./keluargaKatolik.vue?vue&type=style&index=0&id=55b14eed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b14eed",
  null
  
)

export default component.exports